import { render } from "./DWrapper.vue?vue&type=template&id=eb549998"
import script from "./DWrapper.vue?vue&type=script&lang=js"
export * from "./DWrapper.vue?vue&type=script&lang=js"

import exportComponent from "/assets/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__